var map = {
	"./Bulgarian-alphabet.png": "410a",
	"./CentralMineralBath-Sofia-8a_3.jpg": "b090",
	"./Coat_of_arms_of_Bulgaria.png": "10db",
	"./Martenitsa-blossom.jpg": "88a9",
	"./Tarator-Bg.jpg": "4bf2",
	"./bulgarians-nod-of-head.jpg": "f0b9",
	"./na.png": "46e7",
	"./nestinari-fire.jpg": "c11c",
	"./plovdiv.jpg": "729b",
	"./rose.jpg": "cc0c",
	"./sofia-bulgaria-2-million-people.jpg": "3ec2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e730";